import Grid from '@mui/material/Grid';
import React from 'react';

import ButtonComponent from '../../../../../components/Buttons/ButtonComponent';

const ButtonPecahPosView = (props) => {
    return (
        <div className="row">
            <div className='col-12'>
                <Grid container item spacing={1} direction="row" style={{ 'maxWidth': '100vw', margin: '0px', columnGap: '8px', rowGap: '10px' }}>
                    {ButtonComponent.ReloadButton(props.ReloadData)}
                    {ButtonComponent.PrintButton(props.PrintData)}
                </Grid>
            </div>
        </div>
    )
}

export default ButtonPecahPosView;